var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-table',{attrs:{"sampleSetCode":_vm.sampleSetCode,"disabled":_vm.disabled,"baseInfo":_vm.baseInfo},on:{"reload":function($event){return _vm.$emit('reload')}}})}
var staticRenderFns = []

export { render, staticRenderFns }